document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.sort-tab').forEach(tab => {
        tab.addEventListener('click', (e) => {
            const container = e.target.closest('div[id^="sortTabs"]');
            container.querySelectorAll('.sort-tab').forEach(b => b.classList.remove('is-active'));
            e.target.classList.add('is-active');
        });
    });
});